import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { CostingService } from "./costing.service";
import {  CostingSheetResponse,EnquiryIdreq,EnquiryAssessmentInfoModel, EnquiryAssessmentResponseModel, EnquiryAssessmentUpdateReq, QuoteRequest, getAllEnquiryInfoReq, ContainersReq } from "@gtpl/shared-models/enquiry-management";
import { CommonResponse } from "@gtpl/shared-models/masters";

@ApiTags('costSheet')
@Controller('costSheet')
export class CostSheetController {
    constructor(
        private costsheetService: CostingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }

    //To get enquiries with quotation sent status 
    @Post('/getQuotationSentEnquiries')
    async getQuotationSentEnquiries(@Body() req:getAllEnquiryInfoReq): Promise<CommonResponse> {
        try {
            return await this.costsheetService.getQuotationSentEnquiries(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getEnquiryNo')
    async getEnquiryNo(@Body() req:getAllEnquiryInfoReq): Promise<CommonResponse> {
        try {
            return await this.costsheetService.getEnquiryNo(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    //API to update approval status of enquiry
    @Post('/confirmEnquiry')
    async confirmEnquiry(@Body() req:EnquiryAssessmentUpdateReq): Promise<CommonResponse> {
        try {
            return await this.costsheetService.confirmEnquiry(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    //API to calculate cost for a enquiry
    @Post('/generateCostSheet')
    async generateCostSheet(@Body() req:EnquiryIdreq): Promise<CostingSheetResponse> {
        try {
            return await this.costsheetService.generateCostSheet(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CostingSheetResponse, error);
        }
    }
    
    @Post('/UpdateEnquiry')
    async UpdateEnquiry(@Body() req:QuoteRequest): Promise<CommonResponse> {
        try {
            return await this.costsheetService.UpdateEnquiry(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/UpdateBuyerWisePrices')
    async UpdateBuyerWisePrices(@Body() req:QuoteRequest): Promise<CommonResponse> {
        try {
            return await this.costsheetService.UpdateBuyerWisePrices(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/UpdateCostingApproval')
    async UpdateCostingApproval(@Body() req:EnquiryAssessmentUpdateReq): Promise<CommonResponse> {
        try {
            return await this.costsheetService.UpdateCostingApproval(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getCostSheetInfo')
    async getCostSheetInfo(@Body() req:EnquiryIdreq): Promise<CostingSheetResponse> {
        try {
            return await this.costsheetService.getCostSheetInfo(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CostingSheetResponse, error);
        }
    }

    @Post('/getEnquiryDestinations')
    async getEnquiryDestinations(@Body() req:getAllEnquiryInfoReq): Promise<CommonResponse> {
        try {
            return await this.costsheetService.getEnquiryDestinations(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getEnquiryUnits')
    async getEnquiryUnits(@Body() req:getAllEnquiryInfoReq): Promise<CommonResponse> {
        try {
            return await this.costsheetService.getEnquiryUnits(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/updateConfirmedContainers')
    async updateConfirmedContainers(@Body() req:ContainersReq): Promise<CommonResponse> {
        try {
            return await this.costsheetService.updateConfirmedContainers(req);
        }
         catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    
}